export const tradeStatusColor: Record<string, string> = {
  SUCCESS: 'bg-status-completed',
  PROCESSING: 'bg-status-processing',
  FAILED: 'bg-status-negative',
  REJECTED: 'bg-status-negative',
  UNCONFIRMED: 'bg-status-neutral'
};

export const fallbackTradeStatusColor = 'bg-status-neutral';
